export const PERMISSIONS = {
    VIEW_ORGANIZATION_MEMBERS: 'view_organization_members',
    VIEW_ORGANIZATION_INTEGRATION: 'view_organization_integration',
} as const;

export type Permission = typeof PERMISSIONS[keyof typeof PERMISSIONS];

export const ROLE_PERMISSIONS: Record<string, Permission[]> = {
    superAdmin: [
        PERMISSIONS.VIEW_ORGANIZATION_MEMBERS,
        PERMISSIONS.VIEW_ORGANIZATION_INTEGRATION,
    ],
    admin: [
        PERMISSIONS.VIEW_ORGANIZATION_MEMBERS,
        PERMISSIONS.VIEW_ORGANIZATION_INTEGRATION,
    ],
    editor: [],
};

export const hasPermission = (permission: Permission, role: 'superAdmin' | 'admin' | 'editor' ) => {
    return ROLE_PERMISSIONS[role]?.includes(permission);
};